import Login from "pages/login/Login";
import React from "react";
import { useSelector } from "react-redux";
import { renderRoutes } from "react-router-config";
import { useGetExtensionSecretKey } from "service/query/extension.query";

import Snackbar from "../components/Snackbar";
import History from "../history";

const Main = ({ route }) => {
  const init = useSelector((state) => state.auth.init);
  const ready = useSelector((state) => state.auth.ready);
  useGetExtensionSecretKey({ enabled: !!init });

  if (!ready) {
    return null;
  }
  if (!init) {
    return (
      <React.Fragment>
        <Login />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <History />
      <Snackbar />
      {route ? renderRoutes(route.routes) : this.props.children}
    </React.Fragment>
  );
};

export default Main;
